import {useScopeTranslation} from '@uigstudio/uig-nextjs-helper';

import {filterableDistricts, useFilters} from '~providers/FiltersProvider';
import {If} from '~atoms/If';
import Checkboxes from '~molecules/FiltersMenu/Checkboxes';
import {Partner, Section, SectionName} from '~molecules/FiltersMenu/styles';
import {FieldRange} from '~atoms/FieldRange';
import {RangeSlider} from '~atoms/RangeSlider';
import {Checkbox} from '~atoms/Checkbox';
import {toggleInArray} from '~utils/object';
import {PartnersResponse} from '~types/Partner';

type FiltersProps = {
    partners?: PartnersResponse;
    isList?: boolean;
};

const Filters = ({partners, isList = false}: FiltersProps) => {
    const t = useScopeTranslation('common', 'filters');
    const commonT = useScopeTranslation('common');
    const {filters, setFilter, filtersWhitelist} = useFilters();

    return (
        <>
            <If condition={filtersWhitelist.includes('myBidsStatus')}>
                <Checkboxes filterName={'myBidsStatus'} isList={isList} />
            </If>
            <If condition={filtersWhitelist.includes('myPlotsStatus')}>
                <Checkboxes filterName={'myPlotsStatus'} isList={isList} />
            </If>
            <If condition={filtersWhitelist.includes('status')}>
                <Checkboxes
                    filterName={'status'}
                    sectionName={t('status.sectionName')}
                    isList={isList}
                />
            </If>
            <If condition={filtersWhitelist.includes('price')}>
                <Section>
                    <SectionName>{t('priceRange.sectionName')}</SectionName>
                    <FieldRange
                        placeholder={{min: '0', max: '10000'}}
                        value={filters.price}
                        onChange={(range) => setFilter('price', range)}
                        type="currency"
                        textFieldProps={{min: 0, step: 100}}
                        isList={isList}
                    />
                </Section>
            </If>
            <If condition={filtersWhitelist.includes('distanceFromHq')}>
                <Section>
                    <SectionName>{t('distanceFromHq.sectionName')}</SectionName>
                    <RangeSlider
                        min={0}
                        max={800}
                        value={filters.distanceFromHq}
                        onChange={(range) => setFilter('distanceFromHq', range)}
                    />
                </Section>
            </If>
            <If condition={filtersWhitelist.includes('districts')}>
                <Section>
                    <SectionName>{t('district.sectionName')}</SectionName>
                    {filterableDistricts.map((district) => (
                        <Checkbox
                            key={district}
                            label={commonT(`districts.${district}`)}
                            value={filters.districts.includes(district)}
                            cy={`${isList ? 'list-' : 'map-'}district-${district}`}
                            onChange={() =>
                                setFilter(
                                    'districts',
                                    toggleInArray(filters.districts, district),
                                )
                            }
                        />
                    ))}
                </Section>
            </If>
            <If condition={filtersWhitelist.includes('partner')}>
                <Section>
                    <SectionName>{t('partners.sectionName')}</SectionName>
                    {(partners || []).map((partner) => (
                        <Partner
                            key={partner.name}
                            selected={filters.partner === partner.name}
                            onClick={() =>
                                setFilter(
                                    'partner',
                                    filters.partner !== partner.name
                                        ? partner.name
                                        : null,
                                )
                            }
                        >
                            {partner.name}
                        </Partner>
                    ))}
                </Section>
            </If>
        </>
    );
};

export default Filters;
